import React, { useState } from "react";
import "./ItemCreate.css";
import BackButton from "../../components/common/BackButton";
import { supabase } from "../../lib/supabaseClient";

// 분실물/습득물 게시글 작성 페이지
const ItemCreatePage = ({ onGoBack }) => {

  // 게시글 작성 폼 데이터
  const [formData, setFormData] = useState({
    type: "분실",
    title: "",
    date: "",
    location: "",
    category: "전자기기",
    status: "찾는 중",
    description: "",
  });

  // 이미지 미리보기 URL
  const [imagePreview, setImagePreview] = useState(null);

  // 업로드할 이미지 파일
  const [imageFile, setImageFile] = useState(null);

  // 입력값 변경 처리
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // 분실/습득 유형 선택
  const handleTypeClick = (selectedType) => {
    let autoStatus = '찾는 중';

    if (selectedType === '분실') autoStatus = '찾는 중';
    if (selectedType === '습득') autoStatus = '보관 중';

    setFormData({
      ...formData,
      type: selectedType,
      status: autoStatus,
    });
  };

  // 이미지 선택 및 미리보기 설정
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImageFile(file);

      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    }
  };

  // 게시글 등록 처리
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // 로그인 사용자 조회
      const {
        data: { user },
        error: authError
      } = await supabase.auth.getUser();

      if (authError || !user) {
        alert("로그인 세션이 만료되었거나 사용자 정보가 없습니다. 다시 로그인 해주세요.");
        return;
      }

      // users 테이블의 실제 id 조회
      const { data: userData, error: userError } = await supabase
        .from('users')
        .select('id')
        .eq('email', user.email)
        .single();

      if (userError || !userData) {
        alert("사용자 정보를 불러오지 못했습니다.");
        return;
      }

      let finalImageUrl = null;

      // 이미지가 있으면 Storage에 업로드
      if (imageFile) {
        const fileExt = imageFile.name.split('.').pop();
        const fileName = `${Date.now()}.${fileExt}`;

        const { error: uploadError } = await supabase.storage
          .from('lost_images')
          .upload(fileName, imageFile);

        if (uploadError) throw uploadError;

        // 업로드한 이미지의 공개 URL 생성
        const { data: urlData } = supabase.storage
          .from('lost_images')
          .getPublicUrl(fileName);

        finalImageUrl = urlData.publicUrl;
      }

      // lost_items 테이블에 게시글 저장
      const { error } = await supabase
        .from('lost_items')
        .insert([
          {
            item_type: formData.type,
            title: formData.title,
            item_date: formData.date,
            location: formData.location,
            category: formData.category,
            status: formData.status === '주인 찾음' ? '완료' : formData.status,
            description: formData.description,
            image_url: finalImageUrl,
            user_id: userData.id
          }
        ]);

      if (error) throw error;

      alert("성공적으로 등록되었습니다!");
      onGoBack();
    } catch (error) {
      console.error("--- Supabase 저장 에러 ---", error.message);
      alert("저장에 실패했습니다: " + error.message);
    }
  };

  // 선택한 유형에 따라 라벨 변경
  const titleLabel = formData.type === '분실' ? '분실물 이름' : '습득물 이름';
  const dateLabel = formData.type === '분실' ? '잃어버린 날짜' : '주운 날짜';
  const locationLabel = formData.type === '분실' ? '잃어버린 장소' : '주운 장소';

  return (
    <div className="create-container">

      {/* 상단 영역 */}
      <div className="create-header">
        <BackButton onClick={onGoBack} />
        <h2 className="create-title">게시글 작성</h2>
      </div>

      <form onSubmit={handleSubmit}>

        {/* 분실/습득 선택 버튼 */}
        <div className="type-button-group">
          <button type="button" className={`type-btn ${formData.type === '분실' ? 'active lost' : ''}`} onClick={() => handleTypeClick('분실')}>분실</button>
          <button type="button" className={`type-btn ${formData.type === '습득' ? 'active found' : ''}`} onClick={() => handleTypeClick('습득')}>습득</button>
        </div>

        {/* 제목 입력 */}
        <div className="form-group">
          <label className="form-label">{titleLabel}</label>
          <input type="text" name="title" className="form-input" value={formData.title} onChange={handleChange} placeholder="예) 에어팟 프로 본체" required />
        </div>

        {/* 카테고리 선택 */}
        <div className="form-group">
          <label className="form-label">카테고리</label>
          <select name="category" className="form-select" value={formData.category} onChange={handleChange}>
            <option value="전자기기">전자기기</option>
            <option value="지갑/신분증">지갑/신분증</option>
            <option value="의류/잡화">의류/잡화</option>
            <option value="기타">기타</option>
          </select>
        </div>

        {/* 날짜 입력 */}
        <div className="form-group">
          <label className="form-label">{dateLabel}</label>
          <input type="date" name="date" className="form-input" value={formData.date} onChange={handleChange} required />
        </div>

        {/* 장소 입력 */}
        <div className="form-group">
          <label className="form-label">{locationLabel}</label>
          <input type="text" name="location" className="form-input" value={formData.location} onChange={handleChange} placeholder="예) 도서관 2층" required />
        </div>

        {/* 현재 상태 선택 */}
        <div className="form-group">
          <label className="form-label">현재 상태</label>
          <select name="status" className="form-select" value={formData.status} onChange={handleChange}>
            {formData.type === '분실' && (
              <>
                <option value="찾는 중">찾는 중 (분실물)</option>
                <option value="주인 찾음">완료 (주인 찾음)</option>
              </>
            )}
            {formData.type === '습득' && (
              <>
                <option value="보관 중">보관 중 (습득물)</option>
                <option value="주인 찾음">완료 (주인 찾음)</option>
              </>
            )}
          </select>
        </div>

        {/* 상세 설명 입력 */}
        <div className="form-group">
          <label className="form-label">상세 설명</label>
          <textarea name="description" className="form-textarea" value={formData.description} onChange={handleChange} placeholder="물건의 특징이나 상세한 정황을 적어주세요." required />
        </div>

        {/* 사진 첨부 */}
        <div className="form-group">
          <label className="form-label">사진 첨부</label>
          <div className="image-upload-box">
            <input type="file" accept="image/*" onChange={handleImageChange} />

            {/* 이미지 미리보기 */}
            {imagePreview && (
              <div>
                <img src={imagePreview} alt="미리보기" className="image-preview" />
              </div>
            )}
          </div>
        </div>

        {/* 등록 버튼 */}
        <div className="submit-btn-group">
          <button type="submit" className="submit-button">게시글 등록하기</button>
        </div>
      </form>
    </div>
  );
};

export default ItemCreatePage;